import { makeStyles } from '@alpha/ui-lib/ui/external';

const useStyles = makeStyles({
  root: {
    background: '#fff',
    borderTop: '1px solid #d0d0d0',
    minHeight: '130px',
    position: 'fixed',
    bottom: 0,
    zIndex: 10,
    left: '60px',
    width: 'calc(100vw - 60px)',
    padding: '40px 20px 40px 20px;',
    display: 'flex',
    justifyContent: 'space-between',
    '& .divider': {
      minHeight: '10px',
      margin: '0px 8px',
    },
    transition: 'opacity 400ms, transform 400ms',
    transform: 'translateY(0)',
    opacity: '1',

    '&.hide': {
      transform: 'translateY(100%)',
      opacity: '0',

    },
  },
  leftContent: {
    marginLeft: '20px', display: 'flex',
  },
  rightContent: {
    marginRight: '32px',
    minWidth: 'fit-content',
    '& button:nth-child(2)': {
      marginLeft: '12px',
      '@media (max-width: 600px)': {
        marginLeft: 'auto',
        marginTop: '12px',
        display: 'block',
      },
    },
  },
  clearButton: {
    minWidth: '114px',
    height: '44px',
    fontSize: '13px',
    borderRadius: '10px',
    padding: '10px 16px',
    gap: '8px',
    background: '#A62B231A',
    color: '#A62B23',
    textTransform: 'none',
  },
  selectedTrades: {
    lineHeight: '13px',
    fontWeight: 400,
  },
  selectedTradesCurrencyPair: {
    display: 'block',
    fontSize: '13px',
    lineHeight: '18px',
    color: '#21252980',
  },
  cancelButton: {
    background: '#fffffff',
    '&:hover': {
      background: '#B9565633',
      color: '#B95656FF',
    },
  },
  approveButton: {
    marginLeft: '12px',
    backgroundColor: '#1E8777',
    border: 'none',
  },
}, { name: 'MassDrawdownActionBar' });

export default useStyles;
